import styled from 'styled-components';

const HeroHomeStyle = styled.section`
	--sizePicture: 100svh;
	--distanceTitleDescription: var(--sp5x);
	--distanceDescriptionButton: var(--sp6x);

	position: relative;

	.title-wrap {
		h1,
		h2,
		p,
		span {
			color: var(--white1000);
		}
	}

	.wrapper-picture {
		position: relative;

		.file-section {
			--fileHeight: var(--sizePicture);

			&::before {
				content: '';
				top: 0;
				left: 0;
				z-index: 2;
				position: absolute;
				width: 100%;
				height: 100%;
				background-color: var(--green1000);
				opacity: 0.5;
			}
		}
	}

	.info-wrapper {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		z-index: 2;

		.info-content {
			display: flex;
			flex-direction: column;
			align-items: center;
		}

		.description,
		.title {
			text-align: center;
		}

		.description {
			margin-top: var(--distanceTitleDescription);
			margin-bottom: var(--distanceDescriptionButton);
			width: calc(100% * 4 / 6);
			transition: calc(var(--trTime) * 2) ease-in;
			opacity: 0;
		}

		.title {
			width: 100%;
			height: 100%;

			span {
				color: var(--white1000);
				font-size: var(--h1);
			}
		}
	}
	.wrap-button {
		width: fit-content;
		height: fit-content;
		transform: scale(0);
		transition: calc(var(--trTime) * 2) ease-out;
	}

	&.active {
		.description {
			opacity: 1;
			transition-delay: 800ms;
		}

		.wrap-button {
			transition-delay: 800ms;
			transform: scale(1);
		}
	}
	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--distanceTitleDescription: var(--sp4x);
		--distanceDescriptionButton: var(--sp5x);
	}
	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--distanceTitleDescription: var(--sp3x);
		--distanceDescriptionButton: var(--sp4x);
	}
	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
	}
	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}
	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--sizePicture: 768px;
		--distanceTitleDescription: var(--sp2x);
		--distanceDescriptionButton: var(--sp3x);

		.info-wrapper {
			.description {
				width: 100%;
			}
		}
	}
	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		.info-wrapper {
			.description {
				width: calc(100% * 8 / 10);
			}
		}
	}
	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--sizePicture: 812px;

		.info-wrapper {
			.description {
				width: 100%;
			}
		}
	}
`;
export default HeroHomeStyle;
